import { render, staticRenderFns } from "./BoardCloneModal.vue?vue&type=template&id=442a0c5a&scoped=true"
import script from "./BoardCloneModal.vue?vue&type=script&lang=js"
export * from "./BoardCloneModal.vue?vue&type=script&lang=js"
import style0 from "./BoardCloneModal.vue?vue&type=style&index=0&id=442a0c5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442a0c5a",
  null
  
)

export default component.exports